import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageKey, StorageService } from '../../shared/storage.service';
import { Location } from '@angular/common';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-admin-login-layout',
  templateUrl: './admin-login-layout.component.html',
  styleUrls: ['./admin-login-layout.component.css', '../../../assets/css/admin-styles.css']
})
export class AdminLoginLayoutComponent implements OnInit {

  constructor(public location: Location, private router: Router, public storageService: StorageService) {
}

  ngOnInit(): void {
    //this.router.navigate(['/admin/booking']);
    // this.checkToken();
    this.router.navigate(['admin/login']);
  }

  checkToken(): void {
    // Retrieve the token from localStorage
    const token = localStorage.getItem('myToken');
    const role = localStorage.getItem('role');
    
    // Check if token exists
    if (token) {
      try {
        // Decode the token to check expiry (assuming JWT)
        const decodedToken: any = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000);

        // Check if token is expired
        if (decodedToken.exp > currentTime) {
          this.router.navigate(['/booking']);
        } else {
          // If token is expired, clear all items from localStorage
          localStorage.clear();
        }
      } catch (error) {
        // If token decoding fails, clear all items from localStorage
        console.error('Invalid token', error);
        localStorage.clear();
      }
    }
    else{
      this.router.navigate(['/admin/login']);
    }
  }

}
